import withTranslation from '../../globals/components/withTranslation'
import Component from './component'
import { BlockListProps } from './types'

export default withTranslation(Component) as React.ComponentClass<BlockListProps>
